import { render, staticRenderFns } from "./StatsCardImg.vue?vue&type=template&id=7b50b287"
import script from "./StatsCardImg.vue?vue&type=script&lang=js"
export * from "./StatsCardImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports